import UnstyledInfo from "@mui/icons-material/Info";
import UnstyledInfoOutlined from "@mui/icons-material/InfoOutlined";
import type { Theme } from "@mui/material";
import { styled } from "@mui/material";

import { Tooltip as UnstyledTooltip } from "@citrine/atoms/tooltip";

const iconStyles = ({ theme }: { theme: Theme }) => ({
  color: theme.palette.grey[600],
  ":hover": {
    color: theme.palette.grey[500],
  },
});

export const InfoIcon = styled(UnstyledInfo)(iconStyles);
export const InfoIconOutlined = styled(UnstyledInfoOutlined)(iconStyles);

export const Header = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontWeight: theme.typography.fontWeightBold,
  textTransform: "uppercase",
}));

export const Tooltip = styled(UnstyledTooltip)(({ theme }) => ({
  padding: theme.spacing(1.5),
}));
